<button
  class="opacity-80"
  mat-icon-button
  matTooltip="User Settings"
  ptElementTarget="view-settings-button"
  [matMenuTriggerFor]="moreMenu"
>
  <mat-icon>manage_accounts_outline</mat-icon>
</button>
<mat-menu #moreMenu="matMenu" class="view-settings">
  <form [formGroup]="stafferViewSettingsForm">
    <span class="p-2 text-xs font-semibold">User Settings</span>

    <pt-settings-menu-toggle-group-item
      label="Timeline Layout"
      formControlName="orientation"
      ptElementTarget="orientation-button"
      [options]="timelineOrientations"
    />

    <pt-settings-menu-toggle-group-item
      label="Zoom"
      formControlName="zoom"
      ptElementTarget="zoom-button"
      [options]="zoomOptions"
    />

    <button
      mat-menu-item
      ptElementTarget="date-format-button"
      [matMenuTriggerFor]="dateFormatMenu"
    >
      <span class="text-xs">Date Format</span>
    </button>

    <pt-settings-menu-slide-toggle-item
      *ngIf="(timelineStore.orientation$ | ngrxPush) === 'vertical'"
      label="Wide Columns"
      formControlName="thickTracks"
      ptElementTarget="thick-tracks-button"
    />

    <pt-settings-menu-slide-toggle-item
      label="Show Gridlines"
      formControlName="showGridlines"
      ptElementTarget="show-gridlines-button"
    />

    <pt-settings-menu-slide-toggle-item
      label="Hide Empty Days"
      formControlName="hideEmptyDays"
      ptElementTarget="hide-empty-days-button"
    />

    <pt-settings-menu-slide-toggle-item
      label="Hide Cancelled Appointments"
      formControlName="hideCancelledAppointments"
      ptElementTarget="hide-cancelled-appointments-button"
    />
  </form>
</mat-menu>

<mat-menu #dateFormatMenu="matMenu" class="date-format-menu">
  @for (option of dateFormatOptions; track option.value) {
    <button
      mat-menu-item
      [ngClass]="{
        'selected-format':
          stafferViewSettingsForm.value.dateFormat === option.value
      }"
      (click)="selectDateFormat(option.value)"
    >
      <span class="text-xs">{{ option.label }}</span>
    </button>
  }
</mat-menu>
